import { observer } from 'mobx-react'
import { FC } from 'react'

import { FlexContainer, Tooltip } from '@avantstay/backoffice-core'

import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'

interface CreatedByPreviewFormatterProps {
  values?: string[]
}

const _CreatedByPreviewFormatter: FC<CreatedByPreviewFormatterProps> = ({ values }) => {
  const { creatorsByRecordTypes, isLoadingCaseCreators } = casesFilterOptionsStore
  if (isLoadingCaseCreators) return '...'

  if (!values?.length) return ''

  const listOfNames = values?.map(
    value => creatorsByRecordTypes?.find(option => option?.id === value)?.name,
  )

  const firstCreator = listOfNames?.[0]
  if (!firstCreator) return ''
  const parsedText = values.length > 1 ? `${firstCreator}, + ${values.length - 1}` : firstCreator
  return (
    <Tooltip
      content={
        <FlexContainer direction="column" alignItems="flex-start">
          {listOfNames.map(name => (
            <p key={name}>{name}</p>
          ))}
        </FlexContainer>
      }
      disabled={listOfNames.length === 0}
    >
      <p>{parsedText}</p>
    </Tooltip>
  )
}

export const CreatedByPreviewFormatter = observer(_CreatedByPreviewFormatter)
